// import React from "react";
// import ReactECharts from "echarts-for-react";
// import { palette, theme as colorTheme } from "../../../../Convoze.theme";

// function CallDirection({cardDetails }) {
//   const inbound = cardDetails?.callDirection?.Inbound || 0;
//   const outbound =
//     cardDetails?.callDirection?.Outbound || 0;

//   const noData = inbound === 0 && outbound === 0;

//   const option = {
//     title: {
//       text: title || "Inbound and Outbound",
//       left: "left",
//     },
//     tooltip: {
//       trigger: "item",
//     },
//     legend: {
//       left: "right",
//     },
//     series: [
//       {
//         name: "Call Direction",
//         type: "pie",
//         radius: ["40%", "70%"],
//         center: ["50%", "70%"],
//         padAngle: 5,
//         startAngle: 180,
//         endAngle: 360,
//         itemStyle: {
//           borderRadius: 10,
//         },
//         label: {
//           show: true,
//           position: "outside",
//           formatter: "{b}: {value|{c}}",
//           fontSize: 14,
//           rich: {
//             value: {
//               fontWeight: 900,
//               fontSize: 16,
//             },
//           },
//         },
//         data: [
//           {
//             value: inbound,
//             name: "Inbound",
//             itemStyle: {
//               // color: "#73C0DE",
//               color : colorTheme('palette', 'callOutbound').value

//             },
//           },
//           {
//             value: outbound,
//             name: "Outbound",
//             itemStyle: {
//               // color: "#AA99FB",
//               color : colorTheme('palette', 'callInbound').value
//             },
//           },
//         ],
//       },
//     ],
//   };

//   return noData ? (
//     <div
//       style={{
//         height: "100%",
//         width: "100%",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         textAlign: "center",
//       }}
//     >
//       <h3 style={{ textAlign: "left",color:"#686868" }}>
//         {title || "Inbound and Outbound"}
//       </h3>
//       <div
//         style={{
//           flex: 1,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           fontSize: "1rem",
//           fontWeight: 600,
//           color: "#999",
//           borderRadius: "8px",
//         }}
//       >
//         No data available
//       </div>
//     </div>
//   ) : (
//     <ReactECharts option={option} style={{ height: "100%", width: "100%" }} />
//   );
// }

// export default CallDirection;

import React, { useRef } from "react";
import ReactECharts from "echarts-for-react";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";
import { Box, Typography } from "@mui/material";

const CallDirection = ({ cardDetails }) => {
  const inbound = cardDetails?.callDirection?.Inbound || 0;
  const outbound = cardDetails?.callDirection?.Outbound || 0;

  const noData = inbound === 0 && outbound === 0;

  const chartRef = useRef(null);

  const option = {
    title: {
      text: "Call Direction",
      left: "left",
      textStyle: {
        fontSize: 14,
        fontWeight: 700,
        color: "#464646",
      },
    },
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "horizontal",
      bottom: 0,
      left: "center",
    },
    series: [
      {
        name: "Call Direction",
        type: "pie",
        radius: ["40%", "70%"],
        center: ["50%", "70%"],
        padAngle: 5,
        startAngle: 180,
        endAngle: 360,
        itemStyle: {
          borderRadius: 10,
        },
        label: {
          show: true,
          position: "outside",
          formatter: "{b}: {value|{c}}",
          fontSize: 14,
          rich: {
            value: {
              fontWeight: 900,
              fontSize: 16,
            },
          },
        },
        data: [
          {
            value: inbound,
            name: "Inbound",
            itemStyle: {
              // color: "#73C0DE",
              color: colorTheme("palette", "callOutbound").value,
            },
          },
          {
            value: outbound,
            name: "Outbound",
            itemStyle: {
              // color: "#AA99FB",
              color: colorTheme("palette", "callInbound").value,
            },
          },
        ],
      },
    ],
  };

  return (
    <Box
      sx={{
        height: "50vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {noData && (
        <Box
          width="100%"
          display="flex"
          justifyContent="space-between"
          mb="20px"
        >
          <Typography
            fontSize={14}
            variant="body2"
            color="#464646"
            fontWeight={700}
          >
            Call Direction
          </Typography>
        </Box>
      )}

      {/* content */}
      {!noData ? (
        <ReactECharts
          option={option}
          style={{ flex: 1 }}
          opts={{ renderer: "svg" }}
        />
      ) : (
        <Box
          flex={1}
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize="1rem"
          fontWeight={600}
          color="#999"
          borderRadius="8px"
        >
          No data available
        </Box>
      )}
    </Box>
  );
};

export default CallDirection;
